import React, { useMemo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import moment from 'moment'
import {
  TabList,
  TabButton,
  Grid,
  NoEvent,
  Row,
  RowTitle,
  CardWrapper
} from './MyEvent.styles'
import MyEventCard from './MyEventCard'
import { getMyUserEvents } from '../../../redux/apis'
import { useRouter } from 'next/router'
import { MyEventAccessory } from '../../../components/MyEventPayment/MyEventAccessory'
import noitems from '../../../assets/noitems.png'

const tabs = [
  {
    value: 'all',
    label: 'All'
  },
  {
    value: 'reviewing',
    label: 'Reviewing'
  },
  {
    value: 'live',
    label: 'Live'
  },
  {
    value: 'draft',
    label: 'Event Draft'
  },
  {
    value: 'end',
    label: 'Ended'
  }
]

export const statusesByTab = {
  all: [
    'draft',
    'incomplete',
    'submitted',
    'active',
    'winnerSelection',
    'closed'
    // 'archived'
  ],
  reviewing: ['submitted'],
  live: ['active'],
  draft: ['draft'],
  end: ['winnerSelection', 'closed']
}

export const statusTitles = {
  draft: 'Event Drafts',
  incomplete_submitted: 'Reviewing',
  scheduled_active: 'Live',
  winnerSelection_closed: 'Ended'
}

const MyEvent = ({}) => {
  const router = useRouter()
  const [tab, setTab] = useState(tabs[0].value)
  const dispatch = useDispatch()
  const { me } = useSelector(state => state.profile)
  const [totalEventsCreatedNumber, setTotalEventsCreatedNumber] = useState(null)

  const { totalEventsCreated } = router.query

  useEffect(() => {
    if (totalEventsCreated) {
      const totalEvents = parseInt(totalEventsCreated, 10)

      if (totalEvents <= 3) setTotalEventsCreatedNumber(totalEvents)
    }
  }, [totalEventsCreated])

  const { data, refetch, isFetching } = useQuery(
    ['PROFILE_MY_EVENTS', tab],
    async () => {
      const { userEvents } = await getMyUserEvents({
        statuses: statusesByTab[tab]
      })

      userEvents.forEach(event => {
        event.customStatus = event.status
        switch (event.status) {
          case 'active':
            if (moment(event.featuredAt?.iso).isAfter(moment())) {
              event.customStatus = 'scheduled'
              return
            }
            if (moment(event.expiresAt?.iso).isBefore(moment())) {
              event.customStatus = 'winnerSelection'
              return
            }
        }
      })

      return userEvents
    },
    {
      staleTime: 5000, // refetch after 5s
      cacheTime: 60000 // store in cache 60sec
    }
  )

  const renderGrid = events => (
    <Grid>
      {events?.map(event => {
        return (
          <CardWrapper>
            <MyEventCard
              key={event.objectId}
              {...event}
              {...me}
              objectId={event.objectId}
              refetch={refetch}
            />
          </CardWrapper>
        )
      })}
    </Grid>
  )

  const renderAll = () => {
    if (!data?.length) return

    const grouped = {
      draft: [],
      incomplete_submitted: [],
      scheduled_active: [],
      winnerSelection_closed: []
    }

    data.forEach(event => {
      switch (event.customStatus) {
        case 'draft':
          grouped.draft.push(event)
          break
        case 'incomplete':
        case 'submitted':
          grouped.incomplete_submitted.push(event)
          break
        case 'scheduled':
        case 'active':
          grouped.scheduled_active.push(event)
          break
        case 'winnerSelection':
        case 'closed':
          grouped.winnerSelection_closed.push(event)
          break
      }
    })

    return Object.keys(grouped).map(key => {
      const list = grouped[key]
      if (!list?.length) return null
      return (
        <Row key={key}>
          <RowTitle>{statusTitles[key]}</RowTitle>
          {renderGrid(list)}
        </Row>
      )
    })
  }

  return (
    <>
      {typeof totalEventsCreatedNumber === 'number' && (
        <MyEventAccessory
          onClose={() => setTotalEventsCreatedNumber(null)}
          totalEventsCreated={totalEventsCreatedNumber}
        />
      )}
      <TabList>
        {tabs.map(({ value, label }) => (
          <TabButton
            key={value}
            onClick={() => setTab(value)}
            isActive={value === tab}
          >
            {label}
          </TabButton>
        ))}
      </TabList>
      {!isFetching && !data?.length && (
        <NoEvent>
          <img src={noitems} />
          <span>NO EVENT YET</span>
          <button onClick={() => router.push('/create/userEvent')}>
            Host Event
          </button>
        </NoEvent>
      )}
      {tab === 'all' ? renderAll() : renderGrid(data)}
    </>
  )
}

export default MyEvent
